import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Toolbar } from 'primereact/toolbar';
import { AppCancellationLetterValidate, LetterShowClick } from '../../../../config/Validate';
import { convertDateFrom, defaultPageRowOptions, defaultRowOptions, responseOptions, SkeletonbodyTemplate, Skeletonitems } from '../../../../appconfig/Settings';
import { getAllDetailsDirect, getSpecificDetailsById, postAllData } from '../../../../service/ProductService';
import { CANCELLATIONLETTER, DOWNLOADCANCELLATIONLETTER, STORECANCELLATIONLETTER } from '../../../../config/ApiConstant';
import { RegCancellationListColumns } from '../../../../appconfig/DatatableSetting';
import { amountTemplate, dateTemplate } from '../../../../appconfig/DatatableTemplateSetting';
import { LettersTab } from '../../LettersTab';
import { CancellationTab } from '../CancellationLetterTab';
import { InputTextarea } from 'primereact/inputtextarea';
import { Calendar } from 'primereact/calendar';
import Loader from '../../../../components/Loadeer/Loader';
import { Checkbox } from 'primereact/checkbox';

export const ApplicationCancellationLetter = () => {
    document.title = 'Application Cancellation Letter | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [errors, setErrors] = useState<any>({});
    const [regNo, setRegNo] = useState<any>(null);
    const [appLetterData, setAppLetterData] = useState<any>({
        RefranceLetDate: new Date(),
        selectedResponses: [],
    });
    const [addLoader, setAddLoader] = useState<boolean>(false);
    const [appLetterList, setappLetterList] = useState<any>([]);
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [buttonVisible, setButtonVisible] = useState<boolean>(true);

    // useEffect
    useEffect(() => {
        gerApplicationCancellationLetter();
    }, []);

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="search-bar mr-3">
                    <i className="pi pi-search"></i>
                    <InputText type="search" className="search-input" onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
                </span>
            </>
        );
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAllFilter()} className="p-button-outlined"></Button>
            </>
        );
    };

    //Clear All Filter
    const clearAllFilter = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
    };

    // Clear all
    const clearAll = () => {
        setRegNo(null);
        setAppLetterData({
            Name: null,
            ToAddress: null,
            RegNo: '',
            RefranceLetDate: new Date(),
            responseOptions: []
        });
        setErrors({});
    };

    // gerApplicationCancellationLetter List
    const gerApplicationCancellationLetter = async () => {
        if (!window.cn(regNo)) {
            try {
                setShowLoading(true);

                const response = await getAllDetailsDirect(CANCELLATIONLETTER + '?cancelby=Application' + '&FileNo=' + regNo + '&search=' + '');
                const { List } = response;
                if (!window.cn(response) && Object.keys(response?.Details).length !== 0) {
                    const { StudF, StudM, StudL, postAddress, RegNo, feePaidApplicationDate, postDist, postPIN, PPhone } = response?.Details;
                    let FromNm = (!window.cn(StudL) ? StudL : '') + ' ' + (!window.cn(StudF) ? StudF : '') + ' ' + (!window.cn(StudM) ? StudM : '');
                    let address =
                        (!window.cn(postAddress) ? postAddress : "") +
                        ", " +
                        (!window.cn(postDist) ? postDist : "") +
                        "-" +
                        (!window.cn(postPIN) ? postPIN : "") +
                        ", " +
                        (!window.cn(PPhone) ? "Mobile-" + PPhone : "");
                    setAppLetterData({
                        ...appLetterData,
                        Name: FromNm,
                        ToAddress: address,
                        RegNo: RegNo,
                        feePaidApplicationDate: convertDateFrom(feePaidApplicationDate)
                    });
                    setappLetterList(List);
                    setShowLoading(false);
                    setButtonVisible(false);
                } else {
                    setButtonVisible(true);
                    setShowLoading(false);
                    setAppLetterData({ ...appLetterData });
                }
            } catch (error: any) {
                if (error.response) {
                    //Spinner False and Set Toast

                    setShowLoading(false);
                    toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
                }
            }
        } else {
            try {
                setPageLoad(false);
                const response = await getAllDetailsDirect(CANCELLATIONLETTER + '?cancelby=Application' + '&search=' + '');

                if (response) {
                    const { List } = response;
                    setappLetterList(List);
                    setPageLoad(true);
                }
            } catch (error: any) {
                if (error.response) {
                    //Spinner False and Set Toast
                    setPageLoad(true);

                    toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
                }
            }
        }
    };

    // onShowClick get User Deatsils
    const getUserDetails = async () => {
        try {
            const { errors, isError } = LetterShowClick(regNo);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setShowLoading(true);
                gerApplicationCancellationLetter();
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setShowLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    //onchange event
    const onInputChange = (e: any, name: string) => {
        let val;
        if (name === 'RefranceLetDate') {
            val = e;
        } else {
            val = (e.target && e.target.value) || e.value || '';
        }

        setAppLetterData({ ...appLetterData, [name]: val });
    };

    // handle checkbox values
    const handleCheckboxChange = (option: string, checked: boolean) => {
        let updated = [...(appLetterData.selectedResponses || [])];

        if (checked) {
            updated.push(option);
        } else {
            updated = updated.filter((item) => item !== option);
        }

        setAppLetterData({ ...appLetterData, selectedResponses: updated });
    };



    // Handle Application Cancellation Letter Submission
    const addappLetterData = async () => {
        try {
            const { errors, isError } = AppCancellationLetterValidate(appLetterData, regNo);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setAddLoader(true);

                const { selectedResponses, ...rest } = appLetterData;

                let requestData = {
                    ...rest,
                    FileNo: Number(regNo),
                    cancelby: 'Application',
                    RegNo: appLetterData?.RegNo,
                    feePaidApplicationDate: convertDateFrom(appLetterData?.feePaidApplicationDate),
                    RefranceLetDate: convertDateFrom(appLetterData?.RefranceLetDate),
                    responses: selectedResponses.join(', '),
                };

                const response = await postAllData(STORECANCELLATIONLETTER, requestData);
                if (response) {
                    setAddLoader(false);
                    toast.current?.show({ severity: 'success', summary: 'Message', detail: response?.data });
                    clearAll();
                    setAppLetterData({});
                    gerApplicationCancellationLetter();
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setAddLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    // Template for actions
    const actionsTemplate = (rowData: any) => {
        return (
            <>
                <div className="actions action-btn">
                    <Button icon="pi pi-download" onClick={() => downloadRegCancellationLetter(rowData?.SrNo)} tooltip="Download" tooltipOptions={{ position: 'top' }} />
                </div>
            </>
        );
    };

    // Download bank entry
    const downloadRegCancellationLetter = async (id: any) => {
        try {
            setLoading(true);

            const response = await getSpecificDetailsById(DOWNLOADCANCELLATIONLETTER, id);

            //Check response and download
            if (response) {
                //PDF Download
                const { file_url } = response;
                setLoading(false);

                //PDF Download
                const fileName = `registration-cancellation-letter-${new Date().getTime()}.pdf`;
                const link = document.createElement('a');
                link.href = file_url;
                link.target = '_blank';
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    return (
        <>
            <LettersTab mainTabLabel="Cancellation Letters" />
            <CancellationTab initialTabLabel="Application Cancellation" />
            <Toast ref={toast} />
            <div className="grid crud-demo mt-2">
                <div className="col-12">
                    <div className="card">
                        <div className="p-fluid formgrid grid align-items-center">
                            <div className="field col-12 md:col-4">
                                <label htmlFor="regNo">
                                    File No <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputText value={!window.cn(regNo) ? regNo : ''} name="regNo" keyfilter="num" autoComplete="off" placeholder="Enter File No." onChange={(e) => setRegNo(e.target.value)} className={errors['regNo'] && 'p-invalid'} />
                                <small className="p-invalid-txt">{errors['regNo']}</small>
                            </div>
                            <div className="field col-12 md:col-1 mt-4">
                                <Button label="Search" className="p-button-primary" onClick={() => getUserDetails()} loading={showLoading} />
                            </div>
                        </div>
                        <hr />
                        <div className="p-fluid formgrid grid">
                            <div className="field col-12 md:col-4">
                                <label htmlFor="Name">Name</label>
                                <InputText value={!window.cn(appLetterData?.Name) ? appLetterData?.Name : ''} name="Name" disabled={true} />
                            </div>

                            {/* Fee Paid Application Date Field */}
                            <div className="field col-12 md:col-4">
                                <label htmlFor="RefranceLetDate">
                                    Fee Paid Application Date <span style={{ color: 'red' }}>*</span>
                                </label>
                                <Calendar
                                    value={
                                        !window.cn(appLetterData?.feePaidApplicationDate)
                                            ? new Date(appLetterData.feePaidApplicationDate)
                                            : null
                                    }
                                    disabled
                                    dateFormat="dd-mm-yy"
                                />

                            </div>

                            {/* Warning letter Date Field */}
                            <div className="field col-12 md:col-4">
                                <label htmlFor="RefranceLetDate">
                                    Warning letter Date <span style={{ color: 'red' }}>*</span>
                                </label>
                                <Calendar value={appLetterData?.RefranceLetDate} dateFormat="dd-mm-yy" onChange={(e: any) => onInputChange(e.value, 'RefranceLetDate')} showIcon className={errors['RefranceLetDate'] && 'p-invalid'} />
                                <small className="p-invalid-txt">{errors['RefranceLetDate']}</small>
                            </div>

                        </div>
                        <div className="p-fluid formgrid grid">
                            <div className="field col-12 md:col-4">
                                <label htmlFor="ToAddress">Address</label>
                                <InputTextarea
                                    value={!window.cn(appLetterData?.ToAddress) ? appLetterData?.ToAddress : ''}
                                    className={errors['ToAddress'] && 'p-invalid'}
                                    name="ToAddress"
                                    rows={4}
                                    onChange={(e) => onInputChange(e, 'ToAddress')}
                                    // disabled={true}
                                />
                                <small className="p-invalid-txt">{errors['ToAddress']}</small>
                            </div>
                            <div className="col-8">
                                <h6>Responses*</h6>
                                <div className="field formgrid grid">
                                    {responseOptions.map((option, index) => (
                                        <div className="field-checkbox col-12 md:col-4" key={index}>
                                            <Checkbox
                                                inputId={option}
                                                checked={appLetterData.selectedResponses?.includes(option)}
                                                onChange={(e) => handleCheckboxChange(option, e.checked)}
                                            />
                                            <label htmlFor={option}>{option}</label>
                                        </div>
                                    ))}
                                </div>
                                {errors['selectedResponses'] && (
                                    <small className="p-invalid-txt">{errors['selectedResponses']}</small>
                                )}
                            </div>

                        </div>
                        <div className="formgrid grid">
                            <div className="field col-12 md:col-12">
                                <div style={{ display: 'flex', float: 'right', gap: 4 }}>
                                    <Button label="Clear" icon="pi pi-times" className="p-button-secondary mr-2" onClick={() => clearAll()} />
                                    <Button label="Save" icon="pi pi-check" onClick={() => addappLetterData()} loading={addLoader} disabled={buttonVisible} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={appLetterList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    rows={defaultRowOptions}
                                    paginator={appLetterList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Data Found"
                                    removableSort
                                >
                                    {RegCancellationListColumns.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                        } else if (col.field === 'created_at') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} />;
                                        } else if (col.field === 'amount') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={amountTemplate} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {RegCancellationListColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {loading === true ? <Loader /> : ''}

        </>
    );
};
